import {
  SAVE_PAGE_LAYOUT_WIDGETS,
  SAVE_WIDGET_THEME_INFO,
  SAVE_FLOATING_BUTTON_DATA,
  SET_ACTIVE_STYLE_TEMPLATE,
  SAVE_ACTIVE_WIDGET_CHANGE_DESIGN_TEMPLATE,
  SAVE_FORM_DATA,
  UPDATE_THEME_BUILDER_DATA,
  SET_THEME_BUILDER_FLOW,
  SAVE_CURRENT_THEME_DATA,
} from '../actionTypes';

const initialState = {
  themeConfig: {},
  pageLayoutWidgets: {},
  floatingButtonWidget: {},
  activeStyleTemplate: null,
  activeWidgetChangeDesignTemplate: null,
  activeHeaderWidgetChangesDesignTemplate: [
    {
      title: 'Header1',
      name: 'Header1',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/DgciMyUJ.webp',
      propsConfig: { name: 'Header1' },
    },
    {
      title: 'Header2',
      name: 'Header2',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/A14QMaR2.webp',
      propsConfig: { name: 'Header2' },
    },
    {
      title: 'Header3',
      name: 'Header3',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/W5zKmQlA.webp',
      propsConfig: { name: 'Header3' },
    },
    {
      title: 'Header4',
      name: 'Header4',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/VRm6Rtfq.webp',
      propsConfig: { name: 'Header4' },
    },
    {
      title: 'Header5',
      name: 'Header5',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/YwOrlZ7f.webp',
      propsConfig: { name: 'Header5' },
    },
    {
      title: 'Header6',
      name: 'Header6',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/pSm3WFCd.webp',
      propsConfig: { name: 'Header6' },
    },
    {
      title: 'Header7',
      name: 'Header7',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/9PKds2fW.webp',
      propsConfig: { name: 'Header7' },
    },
    {
      title: 'Header8',
      name: 'Header8',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/9EZU5sar.webp',
      propsConfig: { name: 'Header8' },
    },
    {
      title: 'Header9',
      name: 'Header9',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/Fxj1DrWT.webp',
      propsConfig: { name: 'Header9' },
    },
    {
      title: 'Header10',
      name: 'Header10',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/JBfWXHfS.webp',
      propsConfig: { name: 'Header10' },
    },
    {
      title: 'Header11',
      name: 'Header11',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/dry5wi03.webp',
      propsConfig: { name: 'Header11' },
    },
    {
      title: 'Header12',
      name: 'Header12',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/bpM8i1ZM.webp',
      propsConfig: { name: 'Header12' },
    },
    {
      title: 'Header13',
      name: 'Header13',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/AYKWj5sp.webp',
      propsConfig: { name: 'Header13' },
    },
    {
      title: 'Header14',
      name: 'Header14',
      imgUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/e7J9Ecma.webp',
      propsConfig: { name: 'Header14' },
    },
  ],
  formData: null,
  themeBuilderData: {
    currentThemeData: null,
    activeBusinessCategory: null,
    activeSubscriptionType: null,
    isActive: false,
    themeBuilderFlowType: null, // Determines whether current flow is for update/create.
  },
};

const widgetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_WIDGET_THEME_INFO:
      return {
        ...state,
        themeConfig: action.data || {},
      };
    case SAVE_PAGE_LAYOUT_WIDGETS:
      return {
        ...state,
        pageLayoutWidgets: action.data || {},
      };
    case SAVE_FLOATING_BUTTON_DATA:
      return {
        ...state,
        floatingButtonWidget: action.data || {},
      };
    case SET_ACTIVE_STYLE_TEMPLATE:
      return {
        ...state,
        activeStyleTemplate: action.data || null,
      };
    case SAVE_ACTIVE_WIDGET_CHANGE_DESIGN_TEMPLATE:
      return {
        ...state,
        activeWidgetChangeDesignTemplate: action.data || null,
      };
    case SAVE_FORM_DATA:
      return {
        ...state,
        formData: action.data || null,
      };
    case UPDATE_THEME_BUILDER_DATA: {
      if (action.data.type === 'activeBusinessCategoryAndSubscription') {
        return {
          ...state,
          themeBuilderData: {
            ...state.themeBuilderData,
            activeBusinessCategory: action?.data?.activeBusinessCategory || null,
            activeSubscriptionType: action?.data?.activeSubscriptionType || null,
          },
        };
      } else if (action.data.type === 'activateThemeBuilder') {
        return {
          ...state,
          themeBuilderData: {
            ...state.themeBuilderData,
            isActive: action.data.isActive,
          },
        };
      }
    }
    case SET_THEME_BUILDER_FLOW: {
      return {
        ...state,
        themeBuilderData: {
          ...state.themeBuilderData,
          themeBuilderFlowType: action.data,
        },
      };
    }

    case SAVE_CURRENT_THEME_DATA: {
      return {
        ...state,
        themeBuilderData: {
          ...state.themeBuilderData,
          currentThemeData: action.data,
        },
      };
    }
    default:
      return state;
  }
};

export default widgetsReducer;
